import React from 'react';
import "./contact.css";

const Contact = () => {
  //const initialValues = { username:"", email:"", subject:"", message:""};
  return (
    <section className="contact container section" id="contact">
      <h2 className="section__title">Get In Touch</h2>

      <div className="contact__container grid">
        <div className="contact__info">
          <h3 className="contact__title">Let's talk about everything</h3>


          <p className="contact__details">Don't like Forms? Send me an E-mail.<br/><a href=''>nikhiljha1803@gmail.com</a></p>
        </div>

        <forms className="contact__form">
          <div className="contact__form-group">
            <div className="contact__form-div">
              <input type="text" className="contact__form-input" name="username"
              placeholder='Enter your Name'/>
            </div>
            <div className="contact__form-div">
              <input type="email" className="contact__form-input" name="email"
              placeholder='Enter your Email'/>
            </div>
          </div>

          <div className="contact__form-div">
              <input type="text" className="contact__form-input" name="subject"
              placeholder='Enter your Subject'/>
            </div>
          <div className="contact__form-div">
              <textarea name="message" id="" cols="30" rows="10"
              className="contact__form-input" placeholder='Write your message'>

              </textarea>
            </div>

        <button className="btn">Send Message</button>
        </forms>
      </div>
    </section>
  )
}

export default Contact